export const API_DEV_URL = 'https://api.clappykudos.com';
export const API_URL = 'https://api.clappykudos.com';

export const CLOUDINARY = {
  CLOUD_NAME: 'dn2epdcz4',
  UPLOAD_PRESETS: 'ml_default',
};

export const INSIGHT_TYPES = {
  DEPT_INSIGHTS: 'DEPT_INSIGHTS',
  ACTIVE_USERS_30D: 'ACTIVE_USERS_30D',
  TOP_USER_PER_VALUE: 'TOP_USER_PER_VALUE',
  CLAPS_EXCHANGED_ALL_TIME: 'CLAPS_EXCHANGED_ALL_TIME',
  CLAPS_EXCHANGED_LAST_WEEKS: 'CLAPS_EXCHANGED_LAST_WEEKS',
  USER_RANKING: 'USER_RANKING',
  VALUES_USAGE: 'VALUES_USAGE',
};

export const USER_RANKINGS = {
  GIVER: 'GIVER',
  RECEIVER: 'RECEIVER',
};

export const ITEM_TYPES = {
  ALL: 'ALL',
  GIVEN: 'GIVEN',
  RECEIVED: 'RECEIVED',
  CLAIM: 'CLAIM',
};

export const RANKING_PAGE_SIZE = 10;

export const SEARCH_PARAMS_NAME = {
  PAGE_RECEIVER: 'pagereceiver',
  PAGE_GIVER: 'pagegiver',
};

export const FILTERS_SEARCH_PARAMS = {
  TYPE: 'type',
  VALUE: 'value',
  DATE: 'date',
  INACTIVE: 'inactive',
  DEPARTMENT: 'DEPARTMENT',
};

export const FILTER_TYPE = {
  ALL: 'all',
  RECEIVED: 'received',
  GIVEN: 'given',
};

export const DATE_FILTERS = {
  LAST_7_DAYS: 'LAST_7_DAYS',
  LAST_30_DAYS: 'LAST_30_DAYS',
  LAST_3_MONTH: 'LAST_3_MONTH',
  ALL_TIME: 'ALL_TIME',
  CUSTOM: 'CUSTOM',
};

export const ROLLBAR_ACCESS_TOKEN = '1fce3e92e8d647ddafff82e5adb2b0e8';

export const INSIGHT_TIME_FILTERS = {
  LAST_30_DAYS: {
    id: 'LAST_30_DAYS',
    label: 'Last 30 days',
  },
  LAST_3_MONTH: {
    id: 'LAST_3_MONTH',
    label: 'Last 3 months',
  },
  ALL_TIME: {
    id: 'ALL_TIME',
    label: 'All time',
  },
};

export const COLORS = [
  '#0088FE',
  '#00C49F',
  '#FFBB28',
  '#FF8042',
  '#39a778',
  '#0d5181',
  '#2e2836',
];
